import { render, staticRenderFns } from "./VehiculoSimulator.vue?vue&type=template&id=2a267e57"
import script from "./VehiculoSimulator.vue?vue&type=script&lang=js"
export * from "./VehiculoSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a267e57')) {
      api.createRecord('2a267e57', component.options)
    } else {
      api.reload('2a267e57', component.options)
    }
    module.hot.accept("./VehiculoSimulator.vue?vue&type=template&id=2a267e57", function () {
      api.rerender('2a267e57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/VehiculoSimulator.vue"
export default component.exports